// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  allowUrls: [
    /https:\/\/thevolte\.com/
  ],
  dsn: SENTRY_DSN || 'https://e97cb27825834ca588e9d1ec5377b598@o1046206.ingest.sentry.io/6022005',
  // Adjust this value in production, or use tracesSampler for greater control
  // tracesSampleRate: 0.1,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});
